import { render, staticRenderFns } from "./RedirectNectRevoke.vue?vue&type=template&id=133112c4&"
import script from "./RedirectNectRevoke.vue?vue&type=script&lang=js&"
export * from "./RedirectNectRevoke.vue?vue&type=script&lang=js&"
import style0 from "./RedirectNectRevoke.vue?vue&type=style&index=0&id=133112c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports